if (!customElements.get('email-popup')) {
  customElements.define(
    'email-popup',
    class EmailPopup extends HTMLElement {
      constructor() {
        super();
        this.SUBSCRIBED_KEY = 'naatka:newsletter-subscribed';
        this.DISMISSED_UNTIL_KEY = 'naatka:newsletter-dismissed-until';
      }

      connectedCallback() {
        this.successPanel = this.querySelector('[data-email-popup-success]');
        this.closeTriggers = Array.from(this.querySelectorAll('[data-email-popup-close]'));

        this.closeTriggers.forEach((trigger) => {
          trigger.addEventListener('click', () => this.dismiss());
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.classList.contains('is-open')) {
            this.dismiss();
          }
        });

        const justSubscribed = this.successPanel && !this.successPanel.hasAttribute('hidden');

        if (justSubscribed) {
          this.markSubscribed();
          this.open();
          return;
        }

        if (this.isSubscribed() || this.isDismissedRecently()) {
          return;
        }

        const delaySeconds = parseFloat(this.dataset.delaySeconds || '0');
        window.setTimeout(() => this.open(), Math.max(delaySeconds, 0) * 1000);
      }

      open() {
        this.classList.add('is-open');
        document.body.classList.add('overflow-hidden');
      }

      dismiss() {
        this.classList.remove('is-open');
        document.body.classList.remove('overflow-hidden');

        if (!this.isSubscribed()) {
          const dismissDays = parseFloat(this.dataset.dismissDays || '7');
          const until = Date.now() + dismissDays * 24 * 60 * 60 * 1000;
          try {
            window.localStorage.setItem(this.DISMISSED_UNTIL_KEY, String(until));
          } catch (error) {
            /* localStorage unavailable — popup will simply show again next visit */
          }
        }
      }

      isSubscribed() {
        try {
          return window.localStorage.getItem(this.SUBSCRIBED_KEY) === 'true';
        } catch (error) {
          return false;
        }
      }

      markSubscribed() {
        try {
          window.localStorage.setItem(this.SUBSCRIBED_KEY, 'true');
        } catch (error) {
          /* localStorage unavailable — non-fatal, popup just won't remember */
        }
      }

      isDismissedRecently() {
        try {
          const until = parseFloat(window.localStorage.getItem(this.DISMISSED_UNTIL_KEY) || '0');
          return Date.now() < until;
        } catch (error) {
          return false;
        }
      }
    }
  );
}
